import script from "./AboutDown.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutDown.vue?vue&type=script&setup=true&lang=js"

import "../assets/CSS/AboutDown.css?vue&type=style&index=0&id=5c1aa7a9&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c1aa7a9"]])

export default __exports__